"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var of_1 = require("rxjs/observable/of");
var ajax_1 = require("rxjs/observable/dom/ajax");
var qs = require("querystring");
var remote_data_utils_1 = require("./remote-data.utils");
var failure = remote_data_utils_1.RemoteDataUtils.failure;
var success = remote_data_utils_1.RemoteDataUtils.success;
var pending = remote_data_utils_1.RemoteDataUtils.pending;
var Subject_1 = require("rxjs/Subject");
var RequestMethod;
(function (RequestMethod) {
    RequestMethod["Get"] = "GET";
    RequestMethod["Post"] = "POST";
    RequestMethod["Put"] = "PUT";
    RequestMethod["Delete"] = "DELETE";
})(RequestMethod = exports.RequestMethod || (exports.RequestMethod = {}));
exports.create = function (baseHref, extraHeaders) {
    var errorSubj$ = new Subject_1.Subject();
    var error$ = errorSubj$.asObservable();
    var request = function (request) {
        var url = "" + baseHref + request.url;
        var xhr = __assign({ withCredentials: true, responseType: 'json' }, request, { headers: __assign({ 'Content-Type': 'application/json; charset=UTF-8' }, extraHeaders, request.headers), url: url });
        return ajax_1.ajax(xhr)
            .map(function (response) { return success(response.response); })
            .catch(function (response) {
            errorSubj$.next(response);
            return of_1.of(failure(response));
        })
            .startWith(pending);
    };
    var get = function (url, query) {
        return request({
            url: buildUrl(url, query),
            method: 'GET',
        });
    };
    var post = function (url, body) {
        return request({
            url: url,
            method: 'POST',
            body: body,
        });
    };
    var remove = function (url, query) {
        if (query === void 0) { query = {}; }
        return request({
            url: buildUrl(url, query),
            method: 'DELETE',
        });
    };
    var put = function (url, body) {
        return request({
            url: url,
            method: 'PUT',
            body: body,
        });
    };
    return {
        RequestMethod: RequestMethod,
        error$: error$,
        request: request,
        get: get,
        put: put,
        post: post,
        remove: remove,
    };
};
function buildUrl(url, query) {
    return query ? url + "?" + qs.stringify(query) : url;
}
